var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNeobox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.0046,
    cy: 17.0046,
    r: 17.0046,
    fill: "#7CF8C4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4958 15.7369C18.0634 16.4662 18.0561 17.4904 17.4782 18.2136L13.5021 23.1897C12.3166 24.6735 9.92703 23.8299 9.94054 21.9323L10.0117 11.9381C10.0252 10.0406 12.4265 9.22247 13.5909 10.7188L17.4958 15.7369Z",
    fill: "#00242F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0566 16.0981C16.4944 16.8305 16.5091 17.8546 17.0921 18.5746L21.1041 23.529C22.3004 25.0063 24.6839 24.1498 24.6566 22.2524L24.5131 12.2588C24.4859 10.3614 22.0785 9.55641 20.925 11.059L17.0566 16.0981Z",
    fill: "#00242F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNeobox);
export default __webpack_public_path__ + "static/media/neobox.4776582fd3d58b453997f1a7fb4eba32.svg";
export { ForwardRef as ReactComponent };